import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		timeline: {
			color: "#616161",
			textAlign: "center",
			paddingTop: 0,
		},
		title: {
			marginBottom: 15,
		}
	} satisfies Record<string, CSSObject>);
